module.exports.locales = require('./locales');
